<template>
  <div id="config-notion">
    <header>
      <div class="icon">
        <h1>Shadow</h1>
        <span class="dot">
          <span></span>
          <span></span>
          <span></span>
        </span>
        <div class="service">Notion</div>
      </div>
      <h2>Connect with Notion</h2>
      <p>Export summary to Notion.</p>
    </header>
    <main>
      <form>
        <dl id="form-el-account">
          <dt>Notion Account</dt>
          <dd>
            <p>Taper Labs</p>
            <!-- <button onclick="javascript:;" id="btn-signin">Sign In</button> -->
            <button onclick="javascript:;" id="btn-change">Change</button>
          </dd>
        </dl>
        <dl id="form-el-db">
          <dt>Select a database</dt>
          <dd>
            <select>
              <option>Meeting Notes</option>
              <option>Meeting Notes</option>
              <option>Meeting Notes</option>
            </select>
            <button onclick="javascript:;" id="btn-refresh">Refresh</button>
          </dd>
        </dl>
        <dl id="form-el-props">
          <dt>Map properties</dt>
          <dd>
            <label>Title</label>
            <select>
              <option>-</option>
              <option>Name</option>
              <option>Short Summary</option>
            </select>
          </dd>
          <dd>
            <label>TL;DR</label>
            <select>
              <option>-</option>
              <option>Name</option>
              <option>Short Summary</option>
            </select>
          </dd>
          <dd>
            <label>Date</label>
            <select>
              <option>-</option>
              <option>Name</option>
              <option>Short Summary</option>
            </select>
          </dd>
        </dl>
        <dl id="form-el-content">
          <dt>Compose Content</dt>
          <dd>
            <div id="content" contenteditable>
              <p><strong>Meeting Attendees</strong></p>
              <p draggable="true" contenteditable="false" class="data">
                <span>Attendee List</span>
                <button class="btn-data-remove">Remove</button>
              </p>
              <p>This meeting summary was taken by Shadow.</p>
            </div>
          </dd>
        </dl>
      </form>
      <p class="btn-insert-wrap">
        <a id="btn-insert" @click="insertData">Insert Data</a>
      </p>
      <div class="btn-group-wrap">
        <button id="btn-remove">Remove</button>
        <button id="btn-done">Done</button>
      </div>
    </main>
  </div>
</template>

<script>
import { Api } from "@/utils/api";

export default {
  name: "ConfigNotion",
  props: {
    msg: String,
  },
  data() {
    return {
      serviceProvider: "notion",
    };
  },
  mounted() {
    // 붙여넣기 이벤트 지정
    addEventListener("paste", (event) => this.pasteEvent(event));

    // console.log(api["info"]({ serviceProvider: this.serviceProvider }));
    console.log(Api.get("test", { query: {} }));
  },
  beforeUnmount() {
    // 붙여넣기 이벤트 지정 해제
    removeEventListener("paste", (event) => this.pasteEvent(event));
  },
  methods: {
    insertData() {
      // TODO: 진행 중
      var div = document.createElement("div");
      div.innerHTML =
        '<p data-v-b5cf4990="" draggable="true" contenteditable="false" class="data"><span data-v-b5cf4990="">Attendee List</span><button data-v-b5cf4990="" class="btn-data-remove">Remove</button></p><p data-v-b5cf4990=""><br></p>';

      document
        .querySelector("#content")
        .execCommand("insertHTML", false, div.innerHTML);
      event.preventDefault();
    },
    pasteEvent(event) {
      {
        let paste = (event.clipboardData || window.clipboardData).getData(
          "text/html"
        );

        var div = document.createElement("div");
        div.innerHTML = paste;

        div.querySelectorAll("*[style]").forEach((node) => {
          node.removeAttribute("style");
        });

        div.querySelectorAll(".Apple-interchange-newline").forEach((node) => {
          node.remove();
        });

        document.execCommand("insertHTML", false, div.innerHTML);
        event.preventDefault();
      }
    },
  },
};
</script>

<style>
body:has(#config-notion) {
  background: #282828;
  color: #fff;
}
</style>

<style scoped>
#config-notion {
  max-width: 720px;
  margin: 0 auto;
  /* padding: 80px 100px; */
  padding: 5.587% 6.9835%;
}

header {
  margin-bottom: 30px;
  text-align: center;
}

header .icon {
  display: grid;
  grid-template-columns: 52px 40px 52px;
  justify-content: center;
  gap: 32px;
  margin-bottom: 30px;
}

header .icon > *:not(.dot) {
  width: 52px;
  height: 52px;
  text-indent: -9999px;
  background-repeat: no-repeat;
  background-size: cover;
}

header .icon h1 {
  background-image: url("@/assets/img/shadow.png");
}

header .icon .service {
  background-image: url("@/assets/img/notion.png");
}

header .icon .dot {
  display: flex;
  justify-content: space-evenly;
  align-self: center;
}

header .icon .dot span {
  display: block;
  width: 6px;
  height: 6px;
  background: #999;
  border-radius: 100%;
}

header h2 {
  margin-bottom: 10px;
  font-size: 28px;
  font-weight: 600;
}

header p {
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #aaa;
}

form dl {
  margin-top: 30px;
}

form dl dt {
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

form dl dd {
  display: grid;
  gap: 12px;
  margin-top: 16px;
  align-items: center;
}

form dl#form-el-account dd {
  grid-template-columns: 1fr 88px;
}

form dl#form-el-db dd {
  grid-template-columns: 1fr 36px;
}

form dl#form-el-props dd {
  grid-template-columns: 120px 1fr;
}

form dl#form-el-content dd {
  grid-template-columns: 1fr;
}

form dl dd p {
  font-size: 14px;
  line-height: 22px;
  color: #ccc;
}

form dl dd label {
  text-indent: 12px;
  font-size: 14px;
  color: #eee;
}

button {
  text-align: center;
}

button,
select {
  position: relative;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  padding: 0 12px;
  border: 1px solid #777;
  border-radius: 5px;
  color: #aaa;
  background-color: #1d2021;
  cursor: pointer;
}

select {
  background-image: url("@/assets/img/arrow.svg");
  background-repeat: no-repeat;
  background-position: center right 12px;
}

#btn-refresh {
  width: 36px;
  height: 36px;
  padding: 0;
  overflow: hidden;
  background-image: url("@/assets/img/refresh.svg");
  background-repeat: no-repeat;
  background-position: center;
  text-indent: -9999px;
}

#content {
  position: relative;
  display: grid;
  grid-auto-rows: min-content;
  gap: 6px;
  height: 234px;
  font-size: 14px;
  line-height: 34px;
  padding: 12px 18px;
  border: 1px solid #777;
  border-radius: 5px;
  background: #1d2021;
  overflow-y: scroll;
}

#content p {
  line-height: normal;
  padding: 5px 0;
  color: #eee;
}

#content p.data {
  position: relative;
  padding: 9.5px 12px;
  border: 1px solid #777;
  border-radius: 5px;
  background: #282828;
  color: #aaa;
  cursor: move;
}

.btn-data-remove {
  position: absolute;
  right: 12px;
  width: 15px;
  height: 18px;
  padding: 0;
  background-color: initial;
  background-image: url("@/assets/img/remove.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14.2px 17.9px;
  border: 0;
  text-indent: -9999px;
  overflow: hidden;
}

p.btn-insert-wrap {
  margin: 12px 0 60px;
  text-align: center;
}

#btn-insert {
  display: inline-block;
  font-size: 14px;
  text-decoration: underline;
  color: #ccc;
}

div.btn-group-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

div.btn-group-wrap button {
  font-size: 16px;
}

#btn-remove {
  background: #000000b3;
}

#btn-done {
  border: 1px solid #d65d0e;
  background: #d65d0e;
  color: #fff;
}
</style>
